// extracted by mini-css-extract-plugin
export default {"splash-animate":"styles_splash-animate__I46Mq"};